import {useState} from 'react';
import {apiPost, usePolling} from '../api';
import {Badge, Stage, fmtTime} from '../components';

export default function Diagnoses() {
  const [status, setStatus] = useState('pending');
  const [open, setOpen] = useState(null);
  const {data, error, loading, refresh} = usePolling('/diagnoses', {status, limit: 50});

  const act = async (id, action) => {
    await apiPost('/diagnoses', {id, action});
    refresh();
  };

  return (
    <div>
      <h2>Diagnoses（LLM 诊断审查队列）</h2>
      <div className="filters">
        <select value={status} onChange={e => setStatus(e.target.value)}>
          <option value="">全部</option>
          {['pending', 'auto_applied', 'approved', 'rejected', 'applied', 'apply_failed']
            .map(s => <option key={s}>{s}</option>)}
        </select>
        {loading && <span className="muted">刷新中…</span>}
      </div>

      {error && <p className="muted">API 错误：{error}</p>}
      {(data || []).map(d => (
        <div className="panel" key={d.id}>
          <div style={{display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap'}}>
            <span className="mono muted">diag#{d.id}</span>
            <Badge v={d.verdict} />
            <span className="mono">{d.error_class}</span>
            {d.material_id && <span className="mono">{d.material_id}</span>}
            {d.run_name && <span className="muted">{d.run_name}</span>}
            {d.candidate && <span className="muted">candidate #{d.candidate}</span>}
            {d.stage_run && <span className="muted"><Stage s={d.stage} /></span>}
            <Badge v={d.status} />
            <span className="muted mono" style={{marginLeft: 'auto'}}>{fmtTime(d.created_at)}</span>
          </div>
          <p style={{margin: '8px 0'}}>{d.explanation || '(无解释)'}</p>
          {d.proposed_fix && (
            <p className="mono muted" style={{margin: '4px 0'}}>
              proposed_fix: {JSON.stringify(d.proposed_fix)}</p>)}
          <div style={{display: 'flex', gap: 8, marginTop: 8}}>
            {d.context && (
              <button className="btn" onClick={() => setOpen(open === d.id ? null : d.id)}>
                {open === d.id ? '收起上下文' : '查看 LLM 上下文'}</button>)}
            {d.status === 'pending' && (
              <>
                <button className="btn primary" onClick={() => act(d.id, 'approve')}>批准</button>
                <button className="btn danger" onClick={() => act(d.id, 'reject')}>拒绝</button>
              </>)}
          </div>
          {open === d.id && <pre className="logbox" style={{marginTop: 10}}>{d.context}</pre>}
        </div>))}
      {data && data.length === 0 && <p className="muted">队列为空</p>}
    </div>
  );
}
